import { isNullOrUndefined, isValidObject } from '@afterpay/utils'
import { Theme, useGetSelectedTheme, useIsDarkMode } from '@afterpaytouch/core'

interface DarkLightSrc {
  dark: string
  light: string
}

type ThemedImage = string | DarkLightSrc

export interface ThemedImageMap {
  [Theme.AP]?: ThemedImage
  [Theme.Cash]?: ThemedImage
  [Theme.Pegasus]?: ThemedImage
  [Theme.Kelpie]?: ThemedImage
}

export const isDarkLightImage = (obj: ThemedImage): obj is DarkLightSrc => {
  return isValidObject(obj) && typeof obj.dark === 'string' && typeof obj.light === 'string'
}

export const useGetThemedImageSrc = (imageMap: ThemedImageMap | null | undefined): string | null => {
  const selectedTheme = useGetSelectedTheme()
  const isDarkMode = useIsDarkMode()

  const sourceOrDarkLightSrc = imageMap?.[selectedTheme]

  if (isNullOrUndefined(sourceOrDarkLightSrc)) {
    return null
  }

  if (isDarkLightImage(sourceOrDarkLightSrc)) {
    return isDarkMode ? sourceOrDarkLightSrc.dark : sourceOrDarkLightSrc.light
  }

  return sourceOrDarkLightSrc
}
